export enum ZoneVariant {
  AVAILABLE = "available",
  OCCUPIED = "occupied",
  /** Tandem partner constraint. Green fill + center slash mark; not selectable. */
  BLOCKED = "blocked",
  DISABLED = "disabled",
  FORBIDDEN = "forbidden",
  TEMP = "temp"
}
